<mat-label class="subHeading ">Zero Dep<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="zero_dep" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="2" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="2" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        ZeroDepForm.controls['from'].hasError('small')
        ||
        ZeroDepForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
